var map = {
	"./a-Group5058.svg": "f7af",
	"./close.svg": "7710",
	"./danger.svg": "4576",
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./identifyingCode.svg": "4cb9",
	"./jinyong.svg": "e899",
	"./link.svg": "18f0",
	"./menu_warn.svg": "5f9f",
	"./nav_IntelligentMarketing.svg": "7d59",
	"./nav_advert.svg": "8462",
	"./nav_auth.svg": "a536",
	"./nav_customer_data_platform.svg": "b9cd",
	"./nav_data_center.svg": "7d83",
	"./nav_masterdata.svg": "e12f",
	"./nav_moments.svg": "6360",
	"./nav_risk.svg": "e209",
	"./nav_wechat.svg": "8cda",
	"./nav_wechat_history.svg": "f1c4",
	"./nav_wechat_magage.svg": "d53e",
	"./nav_wechat_member_center.svg": "131e",
	"./nav_wechat_msgstatistics.svg": "79b2",
	"./nested.svg": "dcf8",
	"./normal.svg": "babc",
	"./password.svg": "2a3d",
	"./safe.svg": "bd01",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./youjiantou.svg": "3f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";